import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 45C175E3-90FF-4F10-B6E2-6A08B0F70FAA
 * name arrow-right-top-bold
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-right-top-bold.svg
 * tags
 */
export const ArrowRightTopBoldIcon = createSvgIcon(<><path d="M3 13.5C3 9.36 6.36 6 10.5 6H13V2L20 8L13 14V10H10.5C8.57 10 7 11.57 7 13.5V21H3V13.5Z" /></>, 'ArrowRightTopBoldIcon');
export default ArrowRightTopBoldIcon